export default __webpack_public_path__ + "exclamation-mark-circle-fill.c48505f2b84524b6.svg";